import { appSync, socketConnected, startListening } from '@betty/toolkit/state';
import { fetchStatus, updateStatus } from './status.slice';
import { BottomSheet } from '@betty/navigation';
import {
  statusBackgroundTokenMap,
  statusBadgeMap,
} from '../content/status.content';
import { navigationRef } from '@betty/navigation';
import { StatusUpdatedEventData } from './status.types';

startListening({
  actionCreator: appSync,
  effect: (_, { dispatch }) => {
    dispatch(fetchStatus());
  },
});

startListening({
  actionCreator: socketConnected,
  effect: (action, { dispatch }) => {
    const socketConnection = action.payload;
    socketConnection.on('StatusProgress', (data: StatusUpdatedEventData) => {
      const { pendingRewards, ...rest } = data;
      const parsedPendingRewards = pendingRewards.map(
        ({ playerRewardId, ...reward }) => ({
          ...reward,
          rewardId: playerRewardId,
        }),
      );

      dispatch(updateStatus({ pendingRewards: parsedPendingRewards, ...rest }));
    });
  },
});

startListening({
  actionCreator: updateStatus,
  effect: (action) => {
    const status = action.payload;

    if (status.playerStatusState.match('ToBePromoted|ToBeDemoted|ToBeKept')) {
      BottomSheet.open({
        namespace: 'status',
        type: 'statusUpdated',
        data: {
          variant: status.playerStatusState,
          status,
        },
        borderGradient: statusBackgroundTokenMap[status.playerStatus],
        headerImageName: statusBadgeMap[status.playerStatus],
        borderStyle: 'allsides',
        // TODO: Fix TS
        onInfo: () => navigationRef.navigate('StatusTerms'),
        scrollable: true,
      });
    }
  },
});
